<template>
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :title="meunTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <div style="display: flex">
              <div id="eduCharts" class="charts-one"></div>
              <div id="jobCharts" class="charts-one"></div>
            </div>
            <div style="display: flex">
              <div id="alumniCharts" class="charts-one"></div>
              <div id="actCharts" class="charts-one"></div>
            </div>
            <div id="programmeCharts" class="barCharts"></div>
            <div id="classCharts" class="barCharts"></div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayout";
var echarts = require("echarts");
export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
  },
  data() {
    return {
      meunItem: null,
      tableLoading: false,
      meunTitle: "数据统计",
    };
  },
  mounted() {
    //渲染成html后调用
    this.getStatisticalTables();
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
    },
    getStatisticalTables() {
      this.$api
        .statisticsIndex({
          token: localStorage.getItem("token"),
        })
        .then(({ data }) => {
          console.log(data);
          var eduStatistics = {}; // 已激活账号校友深造状态分布
          var eduStatistic = [
            { name: "硕士研究生" },
            { name: "博士研究生" },
            { name: "重读本科" },
            { name: "第二学士学位" },
            { name: "其他" },
            { name: "未知" },
          ];
          var eduTotal = 0;
          eduStatistics = Object.entries(data.Data.eduStatistics[0]); // 已激活账号校友深造状态分布
          console.log(eduStatistic);
          for (var i = 0; i < eduStatistics.length; i++) {
            eduTotal += eduStatistics[i][1];
            eduStatistic[i].value = eduStatistics[i][1];
          }
          console.log("total", eduTotal);
          var jobStatistics = {}; // 已激活账号校友工作状态分布
          var jobStatistic = [
            { name: "就业" },
            { name: "自主创业" },
            { name: "自由职业" },
            { name: "深造" },
            { name: "待业" },
          ];
          var jobTotal = 0;
          jobStatistics = Object.entries(data.Data.jobStatistics[0]); // 已激活账号校友工作状态分布
          for (var i = 0; i < jobStatistics.length; i++) {
            jobTotal += jobStatistics[i][1];
            jobStatistic[i].value = jobStatistics[i][1];
          }
          console.log(jobStatistic);
          var alumniTypeStatistics = {};
          var alumniTypeStatistic = [
            { name: "本科生" },
            { name: "研究生" },
            { name: "博士" },
            { name: "staff" },
            { name: "其他" },
          ];
          var aluTotal = 0;
          alumniTypeStatistics = Object.entries(
            data.Data.alumniTypeStatistics[0]
          ); // 已激活账号校友校友类别分布
          for (var i = 0; i < alumniTypeStatistics.length; i++) {
            aluTotal += alumniTypeStatistics[i][1];
            alumniTypeStatistic[i].value = alumniTypeStatistics[i][1];
          }
          var activation = {}; // 校友账号激活占比
          var activate = [{ name: "已激活" }, { name: "未激活" }];
          var actTotal = 0;
          activation = Object.entries(data.Data.activation[0]);
          for (var i = 0; i < activation.length; i++) {
            actTotal += activation[i][1];
            activate[i].value = activation[i][1];
          }
          var programme = {}; // 已激活账号校友专业分布统计
          var prox = [];
          var proy = [];
          var proTotal = 0;
          programme = Object.entries(data.Data.programme[0]);
          for (var i = 0; i < programme.length; i++) {
            proTotal += programme[i][1];
            prox.push(programme[i][1]);
            proy.push(programme[i][0]);
          }
          var classNum = {}; // 每届激活校友人数分布统计
          var clax = [];
          var clay = [];
          var claTotal = 0;
          classNum = Object.entries(data.Data.class[0]); // 每届激活校友人数分布统计
          for (var i = 0; i < classNum.length; i++) {
            claTotal += classNum[i][1];
            clax.push(classNum[i][1]);
            clay.push(classNum[i][0]);
          }
          this.eduPie(eduStatistic, eduTotal);
          this.jobPie(jobStatistic, jobTotal);
          this.alumniPie(alumniTypeStatistic, aluTotal);
          this.actPie(activate, actTotal);
          this.proBar(prox, proy, proTotal);
          this.claBar(clax, clay, claTotal);
        })
        .catch(({ error }) => {});
    },
    //画图
    eduPie(eduStatistic, eduTotal) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("eduCharts")); // 绘制图表
      var dat = [eduStatistic];
      myChart.setOption({
        title: {
          text: "已激活账号校友深造状态分布(总人数" + eduTotal + "人)",
          left: "center",
          top: 30,
          textStyle: {
            // color: "#999",
            fontWeight: "normal",
            fontSize: 14,
          },
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            var result = "";
            result +=
              params.marker +
              params.name +
              "&nbsp;&nbsp;&nbsp;&nbsp;" +
              params.data.value +
              "人";
            return result;
          },
        },
        series: dat.map(function (data) {
          return {
            type: "pie",
            radius: [20, 60],
            top: 80,
            height: "70%",
            left: "center",
            width: 500,
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 1,
            },
            label: {
              alignTo: "edge", //labelLine表示标签引导线末端对齐，edge表示文字对齐
              formatter: "{name|{b}}\n{time|{d}%}",
              margin: 60,
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
              rich: {
                time: {
                  fontSize: 10,
                  color: "#999",
                },
              },
            },
            labelLine: {
              length: 15,
              length2: 0,
              maxSurfaceAngle: 80,
            },
            labelLayout: function (params) {
              const isLeft = params.labelRect.x < myChart.getWidth() / 2;
              const points = params.labelLinePoints;
              // Update the end point.
              points[2][0] = isLeft
                ? params.labelRect.x
                : params.labelRect.x + params.labelRect.width;
              return {
                labelLinePoints: points,
              };
            },
            data: data,
          };
          // ],
        }),
      });
    },
    jobPie(jobStatistic, jobTotal) {
      let jobChart = echarts.init(document.getElementById("jobCharts")); // 绘制图表
      jobChart.setOption({
        title: {
          text: "已激活账号校友工作状态分布(总人数" + jobTotal + "人)",
          left: "center",
          top: 30,
          textStyle: {
            // color: "#999",
            fontWeight: "normal",
            fontSize: 14,
          },
        },

        tooltip: {
          trigger: "item",
          formatter: function (params) {
            var result = "";
            result +=
              params.marker +
              params.name +
              "&nbsp;&nbsp;&nbsp;&nbsp;" +
              params.data.value +
              "人";
            return result;
          },
        },
        series: [
          {
            type: "pie",
            radius: [20, 60],
            top: 80,
            height: "70%",
            left: "center",
            width: 500,
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 1,
            },
            label: {
              alignTo: "edge", //labelLine表示标签引导线末端对齐，edge表示文字对齐
              formatter: "{name|{b}}\n{time|{d}%}",
              margin: 60,
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
              rich: {
                time: {
                  fontSize: 10,
                  color: "#999",
                },
              },
            },
            labelLine: {
              length: 15,
              length2: 0,
              maxSurfaceAngle: 80,
            },
            labelLayout: function (params) {
              const isLeft = params.labelRect.x < jobChart.getWidth() / 2;
              const points = params.labelLinePoints;
              // Update the end point.
              points[2][0] = isLeft
                ? params.labelRect.x
                : params.labelRect.x + params.labelRect.width;
              return {
                labelLinePoints: points,
              };
            },
            data: jobStatistic,
          },
        ],
      });
    },
    alumniPie(alumniTypeStatistic, aluTotal) {
      let alumniChart = echarts.init(document.getElementById("alumniCharts")); // 绘制图表
      var dat = [alumniTypeStatistic];
      alumniChart.setOption({
        title: {
          text: "已激活账号校友校友类别分布(总人数" + aluTotal + "人)",
          left: "center",
          top: 30,
          textStyle: {
            // color: "#999",
            fontWeight: "normal",
            fontSize: 14,
          },
        },

        tooltip: {
          trigger: "item",
          formatter: function (params) {
            var result = "";
            result +=
              params.marker +
              params.name +
              "&nbsp;&nbsp;&nbsp;&nbsp;" +
              params.data.value +
              "人";
            return result;
          },
        },
        series: dat.map(function (data) {
          return {
            type: "pie",
            radius: [20, 60],
            top: 80,
            height: "70%",
            left: "center",
            width: 500,
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 1,
            },
            label: {
              alignTo: "edge", //labelLine表示标签引导线末端对齐，edge表示文字对齐
              formatter: "{name|{b}}\n{time|{d}%}",
              minMargin: 5,
              margin: 60,
              edgeDistance: 10,
              lineHeight: 15,
              rich: {
                time: {
                  fontSize: 10,
                  color: "#999",
                },
              },
            },
            labelLine: {
              length: 15,
              length2: 0,
              maxSurfaceAngle: 80,
            },
            labelLayout: function (params) {
              const isLeft = params.labelRect.x < alumniChart.getWidth() / 2;
              const points = params.labelLinePoints;
              // Update the end point.
              points[2][0] = isLeft
                ? params.labelRect.x
                : params.labelRect.x + params.labelRect.width;
              return {
                labelLinePoints: points,
              };
            },
            data: data,
          };
        }),
      });
    },
    actPie(activate, actTotal) {
      let actChart = echarts.init(document.getElementById("actCharts")); // 绘制图表
      var dat = [activate];
      actChart.setOption({
        title: {
          text: "校友账号激活占比(总人数" + actTotal + "人)",
          left: "center",
          top: 30,
          textStyle: {
            // color: "#999",
            fontWeight: "normal",
            fontSize: 14,
          },
        },

        tooltip: {
          trigger: "item",
          formatter: function (params) {
            var result = "";
            result +=
              params.marker +
              params.name +
              "&nbsp;&nbsp;&nbsp;&nbsp;" +
              params.data.value +
              "人";
            return result;
          },
        },
        series: dat.map(function (data) {
          return {
            type: "pie",
            radius: [20, 60],
            top: 80,
            height: "70%",
            left: "center",
            width: 500,
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 1,
            },
            label: {
              alignTo: "edge", //labelLine表示标签引导线末端对齐，edge表示文字对齐
              formatter: "{name|{b}}\n{time|{d}%}",
              margin: 60,
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
              rich: {
                time: {
                  fontSize: 10,
                  color: "#999",
                },
              },
            },
            labelLine: {
              length: 15,
              length2: 0,
              maxSurfaceAngle: 80,
            },
            labelLayout: function (params) {
              const isLeft = params.labelRect.x < actChart.getWidth() / 2;
              const points = params.labelLinePoints;
              // Update the end point.
              points[2][0] = isLeft
                ? params.labelRect.x
                : params.labelRect.x + params.labelRect.width;
              return {
                labelLinePoints: points,
              };
            },
            data: data,
          };
        }),
      });
    },
    proBar(prox, proy, proTotal) {
      let proChart = echarts.init(document.getElementById("programmeCharts")); // 绘制图表
      proChart.setOption({
        title: {
          text: "已激活账号校友专业分布统计(总人数" + proTotal + "人)",
          left: "center",
          textStyle: {
            // color: "#999",
            fontWeight: "normal",
            fontSize: 16,
          },
        },
        yAxis: {
          data: proy,
          inverse: true,
        },
        grid: {
          left: 325,
          height:"85%"
        },
        xAxis: {
          type: "value",
        },
        series: [
          {
            data: prox,
            type: "bar",
            barWidth:20,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "right", //在上方显示
                  // formatter: '{c}%',//多值的嵌套
                  formatter: function (val) {
                    var v = val.data;
                    if (v > 0) {
                      return (
                        v +
                        "人" +
                        "\xa0" +
                        Math.floor((v / proTotal) * 100 * 100) / 100 +
                        "%"
                      );
                    } else {
                      return "";
                    }
                  },
                  textStyle: {
                    //数值样式
                    color: "black",
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
      });
      proChart.resize({height:proy.length*35})
    },
    claBar(clax, clay, claTotal) {
      let claChart = echarts.init(document.getElementById("classCharts")); // 绘制图表
      claChart.setOption({
        title: {
          text: "每届激活校友人数分布统计(总人数" + claTotal + "人)",
          left: "center",
          top:0,
          textStyle: {
            // color: "#999",
            fontWeight: "normal",
            fontSize: 16,
          },
        },
        yAxis: {
          data: clay,
        },
        xAxis: {
          type: "value",
        },
        grid:{
          height:"70%",
        },
        series: [
          {
            data: clax,
            type: "bar",
            barWidth:20,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "right", //在上方显示
                  // formatter: '{c}%',//多值的嵌套
                  formatter: function (val) {
                    var v = val.data;
                    if (v > 0) {
                      // return v;
                      return (
                        v +
                        "人" +
                        "\xa0" +
                        Math.floor((v / claTotal) * 100 * 100) / 100 +
                        "%"
                      );
                      // return "{b}\n{c}%";
                    } else {
                      return "";
                    }
                  },
                  textStyle: {
                    //数值样式
                    color: "black",
                    fontSize: 14,
                  },
                },
              },
            },
          },
        ],
      });
      claChart.resize({height:clay.length*35})
    },
  },
};
</script>

<style scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
}
.charts-one {
  width: 600px;
  height: 400px;
  margin: auto;
}
.barCharts {
  width: 75vw;
  /* height: 2000px; */
  margin-left: 100px;
  text-align: center;
  margin-top: 100px;
}
</style>


// WEBPACK FOOTER //
// src/pages/dataMgr/statisticalData.vue